var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrypto = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 26,
    viewBox: "0 0 26 26",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.6106 16.145c-1.7363 6.9644-8.79 11.2028-15.75519 9.4661-6.96231-1.7364-11.20072-8.7905-9.463594-15.75442 1.735504-6.96516 8.789224-11.20397 15.752384-9.467657 6.9647 1.736317 11.2027 8.791247 9.4664 15.755977z",
    fill: "#090719"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.7318 11.1485c.2588-1.72982-1.0583-2.65973-2.8592-3.28007l.5842-2.34325-1.4263-.35547-.5688 2.2815c-.3749-.09344-.7601-.18159-1.1427-.26894l.5728-2.29653-1.4256-.35547-.5846 2.34244c-.3103-.07069-.615-.14056-.9108-.21409l.0017-.00732-1.96711-.49115-.37944 1.52344s1.05829.24253 1.03594.25756c.57771.14422.68211.5265.66461.82956l-.66542 2.66949c.03981.0101.09141.0248.14828.0475-.04753-.0118-.09831-.0248-.15072-.0374l-.93275 3.7396c-.07068.1755-.24984.4387-.65365.3388.01422.0207-1.03675-.2588-1.03675-.2588l-.7081 1.6327 1.85616.4627c.34531.0866.68372.1772 1.01684.2625l-.59028 2.37 1.42469.3555.5846-2.3449c.3892.1057.767.2032 1.1367.295l-.5826 2.3339 1.4264.3554.5903-2.3656c2.4322.4603 4.2611.2747 5.031-1.9252.6203-1.7712-.0309-2.7929-1.3106-3.4592.9319-.2149 1.6339-.8279 1.8212-2.0942zm-3.2589 4.5699c-.4408 1.7712-3.4231.8137-4.3899.5736l.7832-3.1399c.9669.2413 4.0674.7191 3.6067 2.5663zm.4412-4.5955c-.4022 1.6112-2.8844.7926-3.6896.5919l.7101-2.84781c.8052.20069 3.3983.57525 2.9795 2.25591z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrypto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crypto.fb7e12fc17ce550f321227ffafc52821.svg";